import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';

import api from 'api';
import WP from 'WP';
import css from 'css';
import Builder from 'partials/Builder';
import HeadMeta from 'partials/HeadMeta';
import Footer from 'partials/Footer';
import ErrorBoundary from 'partials/ErrorBoundary';
import { gtmPush, decodeHtml } from 'helpers';

import { setCurrentView } from 'store';

class Home extends Component {

    componentDidMount() {
        this.mounted = true;

        api.getHomePage()
            .then(resp => {
                if(resp.data.id) {
                    //console.log('HOME: ', resp.data);
                    this.props.setCurrentView(resp.data);

                    // GTM datalayer push
                    if(window.firstLoad === false) {
                        let title = resp.data.yoast.title;
                        if(!title && resp.data.title && resp.data.title.rendered) title = resp.data.title.rendered;
                        if(!title && resp.data.post_title) title = resp.data.post_title;
                        if(!title && resp.data.name) title = resp.data.name; // for terms
                        gtmPush({
                            'event': 'pageview',
                            'page': {
                                'path': '/',
                                'title': decodeHtml(title)
                            }
                        });
                    }
                    window.firstLoad = false;

                } else {
                    this.props.history.replace('/404');
                }
            })
            .catch(e => console.log(e));
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        const { page } = this.props;
        const pageBackground = page && page.acf && page.acf.page_background ? page.acf.page_background : 'white';
        //console.log(page);
        return (
            <Wrapper pageBackground={pageBackground}>

                <HeadMeta page={page} />

                {page &&
                    <div>
                        <ErrorBoundary for="Page builder">
                            <Builder data={page.acf.modules} page={page} />
                        </ErrorBoundary>

                        <ErrorBoundary for="Footer">
                            <Footer />
                        </ErrorBoundary>
                    </div>
                }

            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    page: state.pages[WP.front_page] || null
});

const actions = {
    setCurrentView,
}

export default connect(mapStateToProps, actions)(withRouter(Home));

const Wrapper = styled.div`
    display:block;
    position:relative;
    width:100%;
    background: ${props => css.colors[props.pageBackground]};
`


// WEBPACK FOOTER //
// ./src/views/Home.js